import { API } from "aws-amplify";
import { useCallback } from "react";
import { GraphQLQuery } from "@aws-amplify/api";

import { authLink as authLinkGql } from "../graphql/queries";
import { AuthLink, AuthLinkInput, AuthLinkQuery } from "../API";

export function useAuthLink() {
    const authLink = useCallback(
        async (input: AuthLinkInput): Promise<Partial<AuthLink | null>> => {
            const result = await API.graphql<GraphQLQuery<AuthLinkQuery>>({
                query: authLinkGql,
                variables: { input },
            });

            return result.data?.authLink || null;
        },
        []
    );

    return { authLink };
}
